<template>
    <div class="edit-event">
      <h2>事件管理</h2>
      <div class="bg-dark system-info">
        <p class="header">新增事件</p>
        <div>
          <div class="form-group">
            <label >事件名称</label>
            <input v-model="event.name" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label >事件类型</label>
            <input v-model="event.type" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label >协议组合</label>
            <input v-model="event.cmd" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label >时间间隔</label>
            <input v-model="event.duration" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label >开始时间</label>
            <input v-model="event.start_at" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label >参数</label>
            <input v-model="event.parameters" type="text" class="form-control" placeholder="">
          </div>

        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "edit-event",
        data(){
          return{
            event:{
              name:"",
              type:"",
              cmd:[],
              data_type:'',
              duration:'',
              parameters:[],
              start_at:''
            }
          }
        }
    }
</script>

<style lang="scss" scoped>
  .system-info {
    padding: 30px 60px;

  .header {
    font-size: pxTorem(22px);
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #1f2037;
  }
    .form-control{
      width: 200px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/subSystem/editEvent.vue